import React from "react";

import { useAuthState } from "igfd-commons/src/auth";

import { type FieldConfig, HubSpotFormDialog } from "./HubSpotFormDialog";
import { FORM_IDS } from "./hubspot-config";

interface ReferralDialogProps {
  open: boolean;
  onClose: () => void;
}

export const ReferralDialog = ({ open, onClose }: ReferralDialogProps) => {
  const { user } = useAuthState();

  const fields: FieldConfig[] = [
    {
      name: "email",
      label: "Their email address",
      type: "email",
      required: true,
    },
  ];

  return (
    <HubSpotFormDialog
      open={open}
      onClose={onClose}
      title="Share Ingredifind"
      description="Invite another restaurant. When they join, you'll both get 50 support credits, enough to cover your next menu update. You can invite as many restaurants as you'd like."
      formId={FORM_IDS.referral}
      fields={fields}
      hiddenFields={[{ name: "referred_by_contact", value: user?.email ?? "" }]}
    />
  );
};
